import ParagraphTypeRecipeSearch from './theme/ParagraphTypeVueComponent/ParagraphTypeRecipeSearch.vue'
import ParagraphTypeLeckerCookbook from './theme/ParagraphTypeVueComponent/ParagraphTypeLeckerCookbook.vue'
import ParagraphTypeLeckerUserProfile from './theme/ParagraphTypeVueComponent/ParagraphTypeLeckerUserProfile.vue'
import ParagraphTypeLeckerRecipeSearchFilterTeaser from './theme/ParagraphTypeVueComponent/ParagraphTypeLeckerRecipeSearchFilterTeaser.vue'
import BrandTeaser from './theme/BrandTeaser.vue'

const registerBrandVueComponents = (app) => {
  app.component('ParagraphTypeRecipeSearch', ParagraphTypeRecipeSearch)
  app.component('ParagraphTypeLeckerCookbook', ParagraphTypeLeckerCookbook)
  app.component('ParagraphTypeLeckerUserProfile', ParagraphTypeLeckerUserProfile)
  app.component('ParagraphTypeLeckerRecipeSearchFilterTeaser', ParagraphTypeLeckerRecipeSearchFilterTeaser)
  app.component('BrandTeaser', BrandTeaser)
}

export {
  registerBrandVueComponents
}
